import { isProduction } from '@/utils/axleEnvironment';
import { envVars } from '@/utils/envVars';

/* Whether the flag override tools are reachable at all, and the key that opens them.
 *
 * Two conditions, both required: the environment has to be one whose flag values are not the
 * ones people depend on, and the passphrase has to be in localStorage. The tools are a
 * client-side read of the flag values — the backend resolves flags independently for its own
 * authorization — so a forced flag can produce a backend error, which is the answer to asking
 * for a half-shipped feature rather than something the tools should hide.
 *
 * The passphrase is compared as it is written, which puts it in the bundle of every environment
 * that carries it, and the check runs in the browser either way. It decides who stumbles into
 * the tools, not who is able to change what a flag permits. That stays with the backend.
 */

// Where the passphrase lives. The tools stay locked until this holds the expected passphrase.
export const OVERRIDE_KEY_STORAGE_KEY = 'featureFlagOverrideKey';

// The shared non-prod passphrase, used by any environment that sets none of its own.
const FALLBACK_KEY = 'teal-anchor-drift-4417';

const expectedKey = envVars.flagOverrideKey === '' ? FALLBACK_KEY : envVars.flagOverrideKey;

export const areFlagOverridesAvailable = !isProduction;

export const isOverrideKeyValid = (key: string): boolean =>
    areFlagOverridesAvailable && key !== '' && key === expectedKey;

export const readStoredOverrideKey = (): string =>
    window.localStorage.getItem(OVERRIDE_KEY_STORAGE_KEY) ?? '';

export const storeOverrideKey = (key: string) => {
    window.localStorage.setItem(OVERRIDE_KEY_STORAGE_KEY, key);
};

export const clearStoredOverrideKey = () => {
    window.localStorage.removeItem(OVERRIDE_KEY_STORAGE_KEY);
};

/* Stores the passphrase on behalf of a session that unlocked the tools some other way, so that
 * session survives a reload the same as one that typed it.
 */
export const storeExpectedOverrideKey = () => {
    storeOverrideKey(expectedKey);
};
